import RedeemModal from './RedeemModal';

export default RedeemModal;
